"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
var React = require("react");
var styled_components_1 = require("styled-components");
var core_1 = require("../core");
var hexToHsl_1 = require("../helper/hexToHsl");
var hslToHex_1 = require("../helper/hslToHex");
var calculateHex = core_1.memo(function (values, ranges, easing) {
    var min = ranges[0], max = ranges[1];
    var _a = hexToHsl_1.hexToHsl(min), minH = _a[0], minS = _a[1], minL = _a[2];
    var _b = hexToHsl_1.hexToHsl(max), maxH = _b[0], maxS = _b[1], maxL = _b[2];
    var hue = core_1.interpolate(values, [minH, maxH], easing);
    var saturation = core_1.interpolate(values, [minS, maxS], easing);
    var lightness = core_1.interpolate(values, [minL, maxL], easing);
    return hslToHex_1.hslToHex(hue, saturation, lightness);
});
exports.hex = function (value, range, easing) { return function (props) {
    var theme = props.theme;
    var values = core_1.getValue(value, theme);
    var ranges = core_1.getRange(range, theme);
    if (ranges.length === 1) {
        return ranges[0];
    }
    return calculateHex(values, ranges, easing);
}; };
exports.useHex = function (value, range, easing) {
    var theme = React.useContext(styled_components_1.ThemeContext);
    return exports.hex(value, range, easing)({ theme: theme });
};
//# sourceMappingURL=hex.js.map